import { useMemo } from "react";

import type { Voucher_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import * as Shared from "../../../_shared";
import * as Converter from "../converter";
import { useVoucherUpdate } from "./use-update";

type Props = {
	hotelID: string;
	voucherID: string;

	queryData: Voucher_EditPageQuery;
};

export const useInitialized = ({ queryData }: Props) => {
	const inputModel = useMemo(() => Converter.serverModelToInputModelConverter({ queryData }), [queryData]);

	const { viewModel, onSetViewModel, onChangeInSale, onResetViewModel } = Shared.Model.FormModel.useFormModel({
		inputModel,
	});

	const { onVoucherUpdate } = useVoucherUpdate({ viewModel, onSuccessCallback: onResetViewModel });

	return {
		viewModel,
		onSetViewModel,
		onChangeInSale,
		//
		onVoucherUpdate,
	};
};
